import {createStore, createEvent, createEffect, sample} from 'effector';
import {UsersState, UserDetailResponse} from '../model/types';
import {usersService} from '../service/api';

export const fetchUserDetailRequested = createEvent<string>();
export const toggleUserFollowRequested = createEvent<{userId: string; isFollowing: boolean}>();

export const fetchUserDetailFx = createEffect(async (id: string): Promise<UserDetailResponse> => {
  return await usersService.getUserById(id);
});

export const toggleUserFollowFx = createEffect(
  async ({
    userId,
    isFollowing,
  }: {
    userId: string;
    isFollowing: boolean;
  }): Promise<{userId: string; isFollowing: boolean}> => {
    await usersService.toggleUserFollow(userId, isFollowing);
    return {userId, isFollowing: !isFollowing};
  },
);

export const $usersStore = createStore<UsersState>({
  selectedUser: null,
  loading: false,
  error: null,
});

$usersStore
  .on(fetchUserDetailRequested, (state) => ({
    ...state,
    loading: true,
    error: null,
  }))
  .on(fetchUserDetailFx.doneData, (state, user) => ({
    ...state,
    selectedUser: user,
    loading: false,
    error: null,
  }))
  .on(fetchUserDetailFx.failData, (state, error) => {
    // console.log(error);
    return {
      ...state,
      loading: false,
      error: error.message,
    };
  })
  .on(toggleUserFollowFx.doneData, (state, {userId, isFollowing}) => {
    if (!state.selectedUser || state.selectedUser.id !== userId) {
      return state;
    }

    return {
      ...state,
      selectedUser: {
        ...state.selectedUser,
        is_followed_by_me: isFollowing,
      },
    };
  })
  .on(toggleUserFollowFx.failData, (state, error) => {
    // console.log('Follow action failed:', error);
    return {
      ...state,
      error: error.message,
    };
  });

sample({
  clock: fetchUserDetailRequested,
  target: fetchUserDetailFx,
});

sample({
  clock: toggleUserFollowRequested,
  target: toggleUserFollowFx,
});